import './rodape.css'

export default function Rodape() {
      return (
            <footer className='container-fluid py-3 bg-rodape text-center'>
                  <i className="bi bi-c-circle me-1"></i>
                  Todos os direitos reservados - 2024
            </footer>
      )
}